import { HTTPWithoutAuth } from '@/services/httpWithoutAuth'

export default {
  async getVersion() {
    return await HTTPWithoutAuth.get('/version/')
  }
}
